import { MultiAppSelectLabel } from './renderers/MultiAppSelectLabel';
import { AppSelectLabel } from './renderers/AppSelectLabel';
import { DateRangeLabel } from './renderers/DateRangeLabel';
import { SelectLabel } from './renderers/SelectLabel';
import { MultiSelectLabel } from './renderers/MultiSelectLabel';
import { BundleLabel } from './renderers/BundleLabel';
import DatePickerLabel from './renderers/DatePickerLabel';

export const GET_LABEL_RENDER_BY_CONTROL_TYPE = {
  multiSelect: MultiSelectLabel,
  select: SelectLabel,
  dateRange: DateRangeLabel,
  datePicker: DatePickerLabel,
  appSelect: AppSelectLabel,
  multiAppSelect: MultiAppSelectLabel,
  bundle: BundleLabel
};

const defaultTooltipRenderer = ({ value }) => value?.label;

const multiSelectTooltipRenderer = ({
  shouldRenderCounterBadge,
  value,
  itemLabelValue
}) =>
  shouldRenderCounterBadge
    ? value.map(item => item.label).join(', ')
    : itemLabelValue;

export const generateTooltipValue = ({
  controlType,
  value,
  shouldRenderCounterBadge,
  itemLabelValue
}) => {
  let tooltip;
  switch (controlType) {
    case 'appSelect': {
      tooltip = defaultTooltipRenderer({ value });
      break;
    }
    case 'multiSelect': {
      tooltip = multiSelectTooltipRenderer({
        shouldRenderCounterBadge,
        value,
        itemLabelValue
      });
      break;
    }
    case 'select': {
      tooltip = defaultTooltipRenderer({ value });
      break;
    }
    // not showing tooltip for this controlType
    default: {
      tooltip = '';
    }
  }

  return tooltip;
};
